(function () {
  function parseGermanDate(dateStr, hourStr, isEnd) {
    if (!dateStr) return null;

    const raw = String(dateStr).trim();
    const match = raw.match(/^(\d{2}):(\d{2}):(\d{4})$/);
    if (!match) return null;

    const [, dd, mm, yyyy] = match;
    const hour = Number(hourStr || 0);

    return new Date(
      Number(yyyy),
      Number(mm) - 1,
      Number(dd),
      hour,
      isEnd ? 59 : 0,
      isEnd ? 59 : 0
    );
  }

  function isActive(now, startDate, startHour, endDate, endHour) {
    const start = parseGermanDate(startDate, startHour, false);
    const end = parseGermanDate(endDate, endHour, true);

    if (start && end) return now >= start && now <= end;
    if (start && !end) return now >= start;
    if (!start && end) return now <= end;
    return true;
  }

  function updateContainHeight(headerVisual, activeItem) {
    if (!headerVisual) return;

    const fitDesktop = activeItem?.dataset.mediaFit || 'cover';
    const fitMobile = activeItem?.dataset.mediaFitMobile || fitDesktop;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const currentFit = isMobile ? fitMobile : fitDesktop;

    if (currentFit !== 'contain') {
      headerVisual.dataset.mediaFitMode = 'cover';
      headerVisual.style.removeProperty('--header-auto-height');
      return;
    }

    const media = activeItem?.querySelector(
      'img.header-bg, img.header-bg--gif, video.header-bg--video, video'
    );

    headerVisual.dataset.mediaFitMode = 'contain';

    if (!media) return;

    function calculate() {
      let naturalWidth = 0;
      let naturalHeight = 0;

      if (media.tagName === 'IMG') {
        naturalWidth = media.naturalWidth || 0;
        naturalHeight = media.naturalHeight || 0;
      }

      if (media.tagName === 'VIDEO') {
        naturalWidth = media.videoWidth || 0;
        naturalHeight = media.videoHeight || 0;
      }

      if (!naturalWidth || !naturalHeight) return;

      const visualWidth = headerVisual.offsetWidth || window.innerWidth;
      const autoHeight = Math.round((visualWidth * naturalHeight) / naturalWidth);

      headerVisual.style.setProperty('--header-auto-height', `${autoHeight}px`);
    }

    calculate();

    if (media.tagName === 'IMG' && !media.complete) {
      media.addEventListener('load', calculate, { once: true });
    }

    if (media.tagName === 'VIDEO' && media.readyState < 1) {
      media.addEventListener('loadedmetadata', calculate, { once: true });
    }
  }

  function applyDynamicHeaderState(headerVisual, activeItem) {
    if (!headerVisual || !activeItem) return;

    const iconColor = activeItem.dataset.iconColor?.trim() || '#ffffff';
    const logoMode = activeItem.dataset.logoMode || 'color';
    const logoPosition = activeItem.dataset.logoPosition || 'inherit';

    const heightDesktop = activeItem.dataset.headerHeightDesktop || '220';
    const heightTablet = activeItem.dataset.headerHeightTablet || '160';
    const heightMobile = activeItem.dataset.headerHeightMobile || '120';

    const mediaPosition = activeItem.dataset.mediaPosition || 'center';
    const mediaScale = activeItem.dataset.mediaScale || '100';
    const mediaFit = activeItem.dataset.mediaFit || 'cover';
    const mediaFitMobile = activeItem.dataset.mediaFitMobile || mediaFit;

    const useCustomLogoPosition = activeItem.dataset.useCustomLogoPosition === 'true';
    const logoPosXDesktop = activeItem.dataset.logoPosXDesktop || '20';
    const logoPosYDesktop = activeItem.dataset.logoPosYDesktop || '50';
    const logoPosXMobile = activeItem.dataset.logoPosXMobile || '50';
    const logoPosYMobile = activeItem.dataset.logoPosYMobile || '50';

    const iconsScale = activeItem.dataset.iconsScale || '100';
    const iconsPosX = activeItem.dataset.iconsPosX || '0';
    const iconsPosY = activeItem.dataset.iconsPosY || '0';

    headerVisual.style.setProperty('--header-dynamic-icon-color', iconColor);
    headerVisual.style.setProperty('--header-h-desktop', `${heightDesktop}px`);
    headerVisual.style.setProperty('--header-h-tablet', `${heightTablet}px`);
    headerVisual.style.setProperty('--header-h-mobile', `${heightMobile}px`);
    headerVisual.style.setProperty('--header-media-scale', `${Number(mediaScale) / 100}`);
    headerVisual.style.setProperty('--header-media-fit', mediaFit);
    headerVisual.style.setProperty('--header-media-fit-mobile', mediaFitMobile);

    headerVisual.style.setProperty('--logo-pos-x-desktop', `${logoPosXDesktop}%`);
    headerVisual.style.setProperty('--logo-pos-y-desktop', `${logoPosYDesktop}%`);
    headerVisual.style.setProperty('--logo-pos-x-mobile', `${logoPosXMobile}%`);
    headerVisual.style.setProperty('--logo-pos-y-mobile', `${logoPosYMobile}%`);

    headerVisual.style.setProperty('--header-icons-scale', `${Number(iconsScale) / 100}`);
    headerVisual.style.setProperty('--header-icons-x', `${iconsPosX}px`);
    headerVisual.style.setProperty('--header-icons-y', `${iconsPosY}px`);

    headerVisual.dataset.customLogoPosition = useCustomLogoPosition ? 'true' : 'false';
    headerVisual.dataset.logoMode = logoMode;
    headerVisual.dataset.logoPosition = logoPosition;
    headerVisual.dataset.mediaPosition = mediaPosition;

    updateContainHeight(headerVisual, activeItem);
  }

  function initHeaderMediaRuntime(container) {
    const items = Array.from(container.querySelectorAll('[data-header-media-item]'));
    const placeholder = container.querySelector('[data-header-media-placeholder]');
    const headerVisual = container.closest('.header-visual');
    const now = new Date();

    let activeItem = null;

    for (const item of items) {
      const ok = isActive(
        now,
        item.dataset.startDate,
        item.dataset.startHour,
        item.dataset.endDate,
        item.dataset.endHour
      );

      if (ok) {
        activeItem = item;
        break;
      }
    }

    items.forEach((item) => {
      const isCurrent = item === activeItem;
      item.hidden = !isCurrent;

      const video = item.querySelector('video');

      if (video) {
        if (isCurrent) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    });

    if (placeholder) {
      placeholder.hidden = !!activeItem;
    }

    applyDynamicHeaderState(headerVisual, activeItem || placeholder);
  }

  function boot(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-header-media-runtime]').forEach(initHeaderMediaRuntime);
  }

  let headerResizeTimer;

  function scheduleHeaderMediaUpdate() {
    clearTimeout(headerResizeTimer);

    headerResizeTimer = setTimeout(function () {
      boot(document);
    }, 150);
  }

  let headerMediaResizeObserver;

  function observeHeaderVisuals() {
    if (!window.ResizeObserver) return;

    if (headerMediaResizeObserver) {
      headerMediaResizeObserver.disconnect();
    }

    headerMediaResizeObserver = new ResizeObserver(function () {
      scheduleHeaderMediaUpdate();
    });

    document.querySelectorAll('.header-visual').forEach(function (headerVisual) {
      headerMediaResizeObserver.observe(headerVisual);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
    observeHeaderVisuals();
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    observeHeaderVisuals();
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    boot(event.target);
    observeHeaderVisuals();
  });

  window.addEventListener('resize', scheduleHeaderMediaUpdate);
  window.addEventListener('orientationchange', scheduleHeaderMediaUpdate);

  setInterval(function () {
    boot(document);
  }, 60000);
})();